<template>
    <span class="text-danger" v-if="mostrarBtnExcluirAnexo">
        <i
            class="fa fa-trash fa-lg icon-button ml-2"
            title="Excluir anexo"
            @click.stop="confirmarExcluirAnexo()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        anexo: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluirAnexo() {
            this.$swal({
                title: 'Exclusão de Arquivo',
                html: `Confirma a exclusão do arquivo <b>${this.anexo.nomeArquivoOriginal}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirAnexo()
                }
            })
        },

        excluirAnexo() {
            this.$store.dispatch('addRequest')
            this.servicos
                .excluirAnexo(
                    this.anexo.projetoId,
                    this.anexo.projetoAnexoId
                )
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAnexosAtualizados')
                        } else {
                            this.$toast.error(
                                'Erro ao excluir anexo.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnExcluirAnexo() {
            return this.$temAcesso('SGTEC-PROJ-ANX-02')
        }
    }
}
</script>
